"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateLocation = exports.showLocationDeniedNotification = exports.setWaitingForLocation = void 0;

var _actionTypes = require("./actionTypes");

var setWaitingForLocation = function setWaitingForLocation(isWaitingForLocation) {
  return {
    type: _actionTypes.SET_WAITING_FOR_LOCATION,
    payload: isWaitingForLocation
  };
};

exports.setWaitingForLocation = setWaitingForLocation;

var showLocationDeniedNotification = function showLocationDeniedNotification() {
  return {
    type: _actionTypes.LOCATION_DENIED,
    payload: true
  };
};

exports.showLocationDeniedNotification = showLocationDeniedNotification;

var updateLocation = function updateLocation(_ref) {
  var slug = _ref.slug,
      placeId = _ref.placeId,
      latitude = _ref.latitude,
      longitude = _ref.longitude,
      bbox = _ref.bbox,
      currentPlace = _ref.currentPlace,
      currentPlaceParent = _ref.currentPlaceParent,
      placeType = _ref.placeType,
      city = _ref.city,
      region = _ref.region,
      isUsingCurrentLocation = _ref.isUsingCurrentLocation,
      isOnline = _ref.isOnline;
  return {
    type: _actionTypes.UPDATE_LOCATION,
    payload: {
      slug: slug,
      placeId: placeId,
      latitude: latitude,
      longitude: longitude,
      bbox: bbox,
      currentPlace: currentPlace,
      currentPlaceParent: currentPlaceParent,
      placeType: placeType,
      city: city,
      region: region,
      isUsingCurrentLocation: isUsingCurrentLocation,
      isOnline: isOnline
    }
  };
};

exports.updateLocation = updateLocation;
//# sourceMappingURL=actions.js.map